import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const colors = {
  bg: '#202328',
  titleBg: '#42434e',
  textColor: '#ffffff'
};

const ModalRoot = styled(Box)`
  border-radius: 8px;
  overflow: hidden;
  color: ${colors.textColor};
  position: absolute;
  top: 70px;
  border-radius: 8px;
  background: ${colors.bg};
  width: 100%;
`;

const ModalHeader = styled(Box)`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  background-color: ${colors.titleBg};
  color: ${colors.textColor};
  border-radius: 8px 8px 0 0;
  font-size: '24px';
  padding: 12px;
`;

const ModalFooter = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  background-color: ${colors.titleBg};
  border-radius: 0 0 8px 8px;
  padding: 12px;
  .btn-default {
    margin-left: 8px;
  }
`;

const ModalBody = styled(Box)`
  padding: 12px;
  max-height: 70vh;
  overflow: auto;
  background: ${colors.bg};
  a {
    color: #006aff;
  }
`;
const CloseButton = styled(Button)`
  width: 35px;
  min-width: 35px;
  height: 35px;
  font-size: 22px;
  color: ${colors.textColor};
`;

export { ModalRoot, ModalHeader, ModalFooter, ModalBody, CloseButton };
